import React, { ReactElement, useState, useEffect } from "react";

import apiRequest from "../../../apis/request";
// types
import { PollMCQsType } from "../../../types";

import { getUserAnswers, updatePollResult } from "../../../apis/firebase";

import { useTranslation } from "react-i18next";

const MultipleChoice = (props: PollMCQsType): ReactElement => {
  const [loading, setIsLoading] = useState(false);
  const [response, setIsResponse] = useState(false);
  const [result, setIsResult] = useState(false);
  const [answer, setAnswer] = useState([]);
  const [answerList, setAnswersList] = useState([]);

  const { t } = useTranslation();

  const [userPollInfo, setUserPollInfo] = useState<any>([]);

  const {
    choices: answers,
    canEditAnswer,
    markCorrectAnswer,
    question,
    selectSize,
    showResults,
    sessionId,
    pollId,
    trackId,
    selectSizeExact,
    submitCallBack,
  } = props;

  useEffect(() => {
    (async () => {
      setUserPollInfo(await getUserAnswers(pollId, sessionId));

      updatePollResult(pollId, sessionId, (data) => {
        if (data && data?.answers) {
          let totalAns = data.totalNumOfAnswers;
          let _answers = Object.entries(data?.answers);
          const answers =
            (_answers &&
              _answers.map((d) => {
                d.percentage = parseFloat((d[1] / totalAns) * 100).toFixed(2);
                d.answer = d[0];
                d.count = d[1];

                return d;
              })) ||
            [];
          setAnswersList(answers);
        }
      });
    })();
  }, [pollId, sessionId]);

  useEffect(() => {
    if (!!userPollInfo && !!userPollInfo?.length) {
      setIsResponse(true);
    }
  }, [userPollInfo]);

  const handleSubmit = async () => {
    if (selectSizeExact && answer.length !== selectSize) {
      return;
    }
    setIsLoading(true);
    try {
      const payload = {
        pollId,
        sessionId,
        trackId,
        answer,
      };

      if (submitCallBack) {
        submitCallBack(payload);
      } else {
        const { status } = await apiRequest(
          "POST",
          "polls/multiplechoice",
          [],
          payload
        );
        setIsLoading(false);
        if (status === 200) {
          setIsLoading(false);
          setIsResponse(true);
        } else {
          setIsResponse(false);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleOnChange = (e) => {
    const { value } = e.target;

    const valueIndex = answer.indexOf(value);

    if (valueIndex > -1) {
      answer.splice(valueIndex, 1);
      setAnswer([...answer]);
    } else {
      if (selectSize > 1) {
        if (answer.length >= selectSize) {
          e.preventDefault();
          e.target.checked = false;
          return;
        }
        answer.push(value);

        setAnswer([...answer]);
      } else {
        setAnswer([value]);
      }
    }
  };

  const handleReset = () => {
    setIsLoading(false);
    setIsResponse(false);
    setAnswer([]);
  };

  return (
    <div className="tm__polls">
      {/* Loader - Start */}
      {loading && (
        <div className="tm__polls-loader d-flex justify-content-center align-items-center">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      )}
      {/* Loader - End */}

      <div className="tm__polls-head tm__polls-head-divider">
        <label className="fs-7 text-primary mb-0">{question}</label>
      </div>
      <div className="tm__polls-body">
        {/* Options - Start */}
        {!response && !result && (
          <ul className="list-style-none p-0 m-0">
            {answers &&
              answers.map((ans, i) => (
                <li key={i} className="mb-2">
                  <div className="form-check">
                    <input
                      className="form-check-input form-check-input-sm"
                      type={selectSize > 1 ? "checkbox" : "radio"}
                      value={ans.choice}
                      id={`ans_${i}`}
                      name="choices"
                      onChange={handleOnChange}
                    />
                    <label
                      className="form-check-label fs-7 ms-2"
                      htmlFor={`ans_${i}`}>
                      {ans.choice}
                    </label>
                  </div>
                </li>
              ))}
          </ul>
        )}
        {/* Options - End */}

        {/* Warning - Start */}
        {!response && !result && (
          <>
            {selectSize > 1 && (
              <span className="d-block fs-7 text-warning mt-3">
                {t("POLLS_HINT_TEXT_SELECT")}{" "}
                {selectSizeExact
                  ? t("POLLS_HINT_TEXT_EXACTLY")
                  : t("POLLS_HINT_TEXT_UPTO")}{" "}
                {selectSize} {t("POLLS_HINT_TEXT_ANSWERS")}
              </span>
            )}
          </>
        )}
        {/* Warning - End */}

        {/* Response - Start */}
        {response && (
          <>
            {showResults && (
              <ul className="list-style-none p-0 mt-2 mb-2">
                {answerList &&
                  answers.map((ans, i) => {
                    const percentage =
                      answerList.find((d) => d.answer === ans.choice)
                        ?.percentage || 0;
                    return (
                      <li key={`ans-${i}`} className="mb-4">
                        <div className="form-progress">
                          <label className="fs-8">{ans.choice}</label>
                          <div className="progress">
                            <div
                              className={`progress-bar ${
                                markCorrectAnswer
                                  ? ans.isCorrectAnswer
                                    ? "bg-success"
                                    : "bg-danger"
                                  : "bg-primary"
                              }`}
                              role="progressbar"
                              style={{
                                width: `${percentage}%`,
                              }}></div>
                            <small>{percentage}%</small>
                          </div>
                        </div>
                      </li>
                    );
                  })}
              </ul>
            )}

            {!showResults && (
              <div className="tm__polls-body">
                {/* Response - Start */}
                <div className="d-flex flex-column align-items-center">
                  <i className="bi bi-check-circle-fill text-primary fs-1"></i>
                  <span>{t("POLLS_THANK_YOU_FOR_ANSWER")}</span>
                </div>
                {/* Response - End */}
              </div>
            )}
          </>
        )}
        {/* Response - End */}
      </div>

      {!result && (
        <div className="tm__polls-footer tm__polls-footer-divider d-flex justify-content-center">
          {!response && (
            <button
              type="button"
              className="btn btn-primary btn-small"
              onClick={() => {
                handleSubmit();
              }}
              disabled={
                (selectSizeExact && answer.length !== selectSize) ||
                answer.length < 1
              }>
              {t("POLLS_SUBMIT_TEXT")}
            </button>
          )}
          {response && canEditAnswer && (
            <button
              type="button"
              className="btn btn-primary btn-small"
              onClick={() => {
                handleReset();
              }}>
              {t("POLLS_EDIT_RESPONSE")}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default MultipleChoice;
